import { useHistory } from 'react-router-dom';
import { useCallback } from 'react';

interface IOptions {
  keepQuery: boolean;
  removeParams: string[];
  params: Record<string, string | number>;
}

const composeUrl = (pathname: string, search?: string, options?: Partial<IOptions>) => {
  const strictOptions: IOptions = {
    keepQuery: true,
    removeParams: [],
    params: {},
    ...options,
  };

  const searchObj = new URLSearchParams(strictOptions.keepQuery ? search : void 0);

  for (const param of strictOptions.removeParams) {
    searchObj.delete(param);
  }
  for (const [k, v] of Object.entries(strictOptions.params)) {
    searchObj.set(k, typeof v === 'string' ? v : v.toString());
  }

  if (searchObj.toString().length > 0) {
    return `${pathname}?${searchObj}`;
  }
  return pathname;
};

export const useHistoryWithSearch = () => {
  const history = useHistory();

  const push = useCallback(
    (pathname: string, options?: Partial<IOptions>) => {
      return history.push(composeUrl(pathname, history.location.search, options));
    },
    [history.push]
  );

  const replace = useCallback(
    (pathname: string, options?: Partial<IOptions>) => {
      return history.replace(composeUrl(pathname, history.location.search, options));
    },
    [history.replace]
  );

  return {
    push,
    replace,
  };
};
